import { Box } from 'reflexbox';
import styled from 'styled-components';
import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';

import CompetencyItem from './items/CompetencyItem';

import OpenQuestionItem from './items/OpenQuestionItem';
import GoalReviewItem from './items/GoalReviewItem';
import SentimentItem from './items/SentimentItem';
import StarsItem from './items/StarsItem';
import DevelopmentPlanItem from './items/DevelopmentPlanItem';

const Description = styled.p`
	color: ${(props) => props.theme.colors.slateBlue};
	font-size: 14px;
	line-height: 24px;
`;

const SectionTitle = styled.h2`
	font-size: 24px;
	font-weight: bold;
`;

export default function ConversationItem({
	item,
	participants,
}: {
	item: graphql.ConversationItem;
	participants: graphql.Participant[];
}) {
	const { localize } = useLocalize();

	if (item.__typename === 'TitleItem') {
		return (
			<Box mb={3}>
				<SectionTitle>{localize(item.title).text}</SectionTitle>
			</Box>
		);
	}

	if (item.__typename === 'ParagraphItem') {
		return (
			<Box mb={4}>
				<Description>
					<QuillText quill={localize(item.content).text} />
				</Description>
			</Box>
		);
	}

	if (item.__typename === 'OpenQuestionItem') {
		return <OpenQuestionItem item={item} participants={participants} />;
	}

	if (item.__typename === 'CompetencyItem') {
		return <CompetencyItem item={item} participants={participants} />;
	}

	if (item.__typename === 'GoalReviewItem') {
		return <GoalReviewItem item={item} participants={participants} />;
	}

	if (item.__typename === 'SentimentItem') {
		return <SentimentItem item={item} participants={participants} />;
	}

	if (item.__typename === 'StarsItem') {
		return <StarsItem item={item} participants={participants} />;
	}

	if (item.__typename === 'DevelopmentPlanItem') {
		return <DevelopmentPlanItem item={item} participants={participants} />;
	}

	console.error('Unknown item type', item.__typename);

	return null;
}
